import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, RouterLinkProps {
    children?: React.ReactNode;
    className?: string;
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    ({ children, className, ...props }, ref) => {
        return (
            <RouterLink {...props} ref={ref} to={props.to} className={className}>
                {children}
            </RouterLink>
        );
    }
);

export default Link;
Link.displayName = 'Link';
